<template>
  <ul class="section-category">
    <li class="category-item" v-for="(item, index) in sectionCategories" :key="item.sectionId">
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="`#icon-1-${index + 1}`" />
      </svg>
      <span class="section-name">{{getSectionName(item)}}</span>
      <span class="price">
        <span class="unit">￥</span>
        <span>{{ `${item.price + item.fee}` | schedule_price }}</span>
      </span>
    </li>
  </ul>
</template>

<script>
import '../../../../stylesheet/iconfont/seatlock'
import op from 'object-path'

export default {
  name: 'SectionCatetory',
  props: {
    sectionCategories: {
      type: Array,
      default: [],
    },
    sectionMap: {
      type: Object,
      default: {},
    },
  },
  methods: {
    getSectionName(item) {
      return op.get(this.sectionMap[item.sectionId], 'sectionName') || ''
    },
  },
}
</script>

<style lang="less" scoped>
.section-category {
  padding: 5px 15px 10px;
  background-color: #fff;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;

  .category-item {
    margin-right: 15px;
    display: flex;
    align-items: center;
    margin-top: 5px;
    flex-shrink: 0;
  }

  .icon {
    width: 19px;
    height: 18px;
  }

  .section-name,
  .price {
    font-size: 13px;
    color: #797d82;
    margin-left: 2px;
  }

  .unit {
    font-size: 8px;
  }
}
</style>



